import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Seo from "../components/Seo";
import('../css/Layout.css')
import('../css/Footer.css')
import('../css/Navbar.css')

const Layout = () => {
    return (
        <>
            <Seo
                title="KhetBazaar - Buy or Sell Land Online"
                description="India's trusted land marketplace to buy, sell, or lease land."
                canonical="https://khetbazaar.in"
            />

            <div className="layout">
                <Navbar />
                <main className="main-content">
                    <Outlet />
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Layout;
